import { Component, inject, input, OnInit, viewChild } from "@angular/core";
import { Router } from "@angular/router";
import { TranslatePipe } from "@ngx-translate/core";

import { AdaaHelper } from "../../../../core/utils";
import { DataTableComponent } from "../../../../shared/components";
import { Constants } from "../../../../shared/constants/constants";
import { AdaaBoolean, PermissionAction } from "../../../../shared/constants/enums";
import { ItemAction, TableButtonClicked } from "../../../../shared/models";
import { PermissionsService, SystemLayoutService } from "../../../../shared/services";

@Component({
  selector: "adaa-data-entry-metrics-list",
  imports: [DataTableComponent, TranslatePipe],
  templateUrl: "./data-entry-metrics-list.html",
  styleUrl: "./data-entry-metrics-list.scss",
})
export class DataEntryMetricsListComponent implements OnInit {
  private _router = inject(Router);
  private _systemLayoutService = inject(SystemLayoutService);
  private _permissionsService = inject(PermissionsService);

  breadcrumb = input.required<string>();

  private _untilDestroyed = AdaaHelper.untilDestroyed();
  Constants = Constants;
  manageMonitoringMetrics: boolean = false;

  adaaDataTable = viewChild.required<DataTableComponent>("adaaDataTable");

  public get disableEditRules(): ItemAction[] {
    const permissons: ItemAction[] = [
      {
        propertyName: "synced",
        compareWith: AdaaBoolean.Y,
        operator: "equal",
      },
    ];

    if (!AdaaHelper.isPMOEntity()) {
      permissons.push({
        propertyName: "type",
        compareWith: Constants.METRICS_TYPE.GLOBAL,
        operator: "equal",
      });
    }

    if (!this.manageMonitoringMetrics) {
      permissons.push({
        propertyName: "type",
        compareWith: Constants.METRICS_TYPE.DIMENSION,
        operator: "equal",
      });
    }

    return permissons;
  }

  public ngOnInit(): void {
    this._permissionsService.isPermissionsLoaded.pipe(this._untilDestroyed()).subscribe((loaded: boolean) => {
      if (!loaded) return;

      this._checkPermissions();
    });

    this._systemLayoutService.hasActiveEntityChanged$.pipe(this._untilDestroyed()).subscribe({
      next: () => {
        this.adaaDataTable().loadTableData(true);
      },
    });
  }

  public getAction(value: TableButtonClicked) {
    switch (value.event) {
      case "view":
        this._router.navigateByUrl(`/console/data-entry/metrics/${value.data.id}`);
        break;
      case "edit":
        value.data.type === Constants.METRICS_TYPE.DIMENSION
          ? this._router.navigateByUrl(`/console/data-entry/metrics/realtime/edit/${value.data.id}`)
          : this._router.navigateByUrl(`/console/data-entry/metrics/edit/${value.data.id}`);
        break;

      default:
        break;
    }
  }

  private _checkPermissions() {
    this.manageMonitoringMetrics = this._permissionsService.hasPermission(
      [
        {
          objectTypeId: Constants.CONSTANT_PERMISSIONS.MANAGE_MONITORING_METRICS,
          permissionAction: PermissionAction.manage,
        },
      ],
      "and"
    );
  }
}
